<template>
  <div class="form-element" v-if="image">
    <div class="form-element__captcha">
      <img :src="`data:image/png;base64,${image}`" />
      <form-input :isNumeric="true" v-model="val" :placeholder="'Kod'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
    val: function (val) {
      this.$emit("input", val);
    },
  },
};
</script>